import { Component, OnInit } from '@angular/core';
import { VoucherService } from '../voucher.service';
import { Storage } from '@ionic/storage';
import { UserProfile } from '../../../models/user-profile.model';
import { RoleAccess } from '../../../models/role-access.model';
import { NavController, ToastController } from '@ionic/angular';
import { ActivatedRoute, Router } from '@angular/router';
import { UserData } from '../../../providers/user-data';
import { UtilService } from '../../../service/util.service';
import * as utf8 from 'crypto-js/enc-utf8';
import AES = require('crypto-js/aes');
import { environment } from '../../../../environments/environment';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-voucher-detail',
  templateUrl: './voucher-detail.page.html',
  styleUrls: ['./voucher-detail.page.scss'],
})
export class VoucherDetailPage implements OnInit {

  token: any;
  userProfile: UserProfile = new UserProfile();
  roleAccess = new RoleAccess();
  id:any='';
  voucher:any=[];
  allCounterList:any='';
  allTierList:any=''
  allCustomerList:any='';
  counterList:any='';
  productList:any='';
  tierList:any='';
  customerList:any='';
  constructor(
    private voucherService: VoucherService,
    private storage: Storage,
    private toastCtrl: ToastController,
    private navCtrl:NavController,
    private userData: UserData,
    private router: Router,
    private activeRoute:ActivatedRoute,
    private utilService:UtilService
  ) { }

  ngOnInit() {
    Promise.all([
      this.storage.get('user_token'),
      this.storage.get('user_profile'),
      this.storage.get('user_menu_access')
    ])
    .then(([token, profile, access]) => {
      if(token) {
        this.token = token;
        this.userProfile = new UserProfile(profile);
        this.roleAccess = this.userData.checkAccess(this.router.url, access, this.userProfile);
        //if(!this.roleAccess || this.roleAccess.update!='1'){
          //this.toastCtrl.create({ duration: 2000, message: 'You Are Not Allowed to Access this Page' }).then(t => t.present());
          //this.navCtrl.navigateForward(['/']);
        //}
        //else{
          this.getData();
        //}
      } else {
        this.toastCtrl.create({ duration: 2000, message: 'Silahkan login terlebih dahulu.' }).then(t => t.present());
        this.navCtrl.navigateForward(['/login']);
      }
    });
  }

  getData() {
    this.activeRoute.queryParams.subscribe((snapshot) => {
      let myKey=environment.myKey;
      this.id = AES.decrypt(snapshot.i, myKey).toString(utf8);
      this.utilService.loadingPresent('Harap tunggu...')
      .then(() => {
        let options = {
          "token" : this.token,
          "id":this.id
        }
        this.voucherService.getVoucherByHeader(options).subscribe((response) => {
          this.utilService.loadingDismiss();
          console.log(response);
          this.voucher = response.results.voucher;
          this.allCounterList = response.results.counter;
          this.allTierList = response.results.tier;
          this.allCustomerList = response.results.customer;
          this.counterList ='';
          this.productList ='';
          this.tierList ='';
          this.customerList ='';
          
          let arrayTier =  this.voucher.tier_id_list !== '' ? String( this.voucher.tier_id_list).split(',') : [];
          if(arrayTier.length>0){
            for(let i=0;i<arrayTier.length;i++){
              let selectedTier = this.allTierList.find(x => x.id ==  arrayTier[i]);
              if(selectedTier){       
                this.tierList +=selectedTier.tier_name+',';
              }
            }
          }
          let arrayCustomer =  this.voucher.customer_id_list !== '' ? String( this.voucher.customer_id_list).split(',') : [];
          if(arrayCustomer.length>0){
            for(let i=0;i<arrayCustomer.length;i++){
              let selectedCustomer = this.allCustomerList.find(x => x.id ==  arrayCustomer[i]);
              if(selectedCustomer){       
                this.customerList +=selectedCustomer.customer_name+' ( '+selectedCustomer.phone+' )'+',';
              }
            }
          }

          if(this.voucher.counter_type=='1'){
            let arraycounter =  this.voucher.counter_list !== '' ? String( this.voucher.counter_list).split(',') : [];
            if(arraycounter.length>0){
              for(let i=0;i<arraycounter.length;i++){
                let selectedCounter = this.allCounterList.find(x => x.id ==  arraycounter[i]);
                if(selectedCounter){
                  let idx =this.allCounterList.indexOf(selectedCounter);            
                  this.counterList +=this.allCounterList[idx].counter_name+',';
                }
              }
            }
          }
          if(this.voucher.product_type=='1'){
            this.productList = this.voucher.product_list;
          }
          if(this.voucher.jadwal_berlaku!=''){
            try {
              // decode JSON string menjadi object JS
              this.voucher.tanggalKhusus = JSON.parse(this.voucher.jadwal_berlaku).tanggalKhusus;
              this.voucher.hariKhusus = JSON.parse(this.voucher.jadwal_berlaku).hariKhusus;
            } catch (e) {
              console.error("Gagal parse tanggal_khusus:", e);
              this.voucher.tanggalKhusus = null;
              this.voucher.hariKhusus = null;
            }
          }
          console.log("Voucher hasil decode:", this.voucher);
        }, () => {
          this.utilService.loadingDismiss();
          this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
        });
      });
    });
  }
  exportToExcel() {
    let dataForExport = [];
    if(this.voucher.detail.length>0){
      for(let i=0;i<this.voucher.detail.length;i++){
        dataForExport.push(
          { No: (i+1), 
            "Voucher Code": this.voucher.detail[i].voucher_code,
            "Status": this.voucher.detail[i].voucher_status,
            "Receipt NO": this.voucher.detail[i].receipt_no 
          }
        );
      }
    }
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataForExport);
    const objectMaxLength: number[] = [];
    dataForExport.forEach(row => {
      Object.values(row).forEach((value, colIndex) => {
        const length = String(value).length;
        objectMaxLength[colIndex] = Math.max(objectMaxLength[colIndex] || 0, length);
      });
    });
    Object.keys(dataForExport[0]).forEach((header, colIndex) => {
      objectMaxLength[colIndex] = Math.max(objectMaxLength[colIndex] || 0, header.length);
    });
    ws['!cols'] = objectMaxLength.map(width => ({ wch: width + 2 }));
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'Voucher.xlsx');
  }
}
